<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      :class="[verticalNavMenuWidth !== 'default' ? 'smallMenu' : '']"
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe"
    >
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" style="background-color: #1e0d61; height: 100%">
        <!-- Header -->
        <div class="flex items-end justify-between" slot="header">
          <!-- 사이드메뉴 상단 로고 이미지 -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/home">
            <img class="fill-current" :src="sideTopImage" :style="sideTopImageStyle" alt="Digital SHM System" />
          </router-link>
        </div>
        <!-- /Header -->

        <!-- Menu Items -->
        <component :is="scrollbarTag" ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings" @ps-scroll-y="psSectionScroll" @scroll="psSectionScroll" :key="$vs.rtl">
          <div ref="verticalNavMenuCt">
            <template v-for="(item, index) in menuItemsUpdated">
              <!-- Group Header -->
              <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" style="white-space: initial !important" :key="`header-${index}`">
                {{ item.header }}
              </span>
              <!-- /Group Header -->

              <template v-else-if="!item.header">
                <!-- Nav-Item -->
                <v-nav-menu-item
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :to="(item.url && typeof item.url === 'object') || item.single ? item.url : null"
                  :href="item.url && typeof item.url === 'string' ? item.url : null"
                  :icon="item.icon"
                  :target="isExternal(item.url) ? '_blank' : '_self'"
                  :isDisabled="item.isDisabled"
                  :group-name="item.groupName"
                  :activeCode="item.activeCode"
                  :refMenuScroll="$refs.verticalNavMenuPs"
                  :refMenuScrollCt="$refs.verticalNavMenuCt"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="truncate" style="white-space: initial !important">{{ item.name }}</span>
                  <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip>
                </v-nav-menu-item>

                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group :key="`group-${index}`" :openHover="openGroupHover" :group="item" :groupIndex="index" :open="isGroupActive(item)" :refMenuScroll="$refs.verticalNavMenuPs" :refMenuScrollCt="$refs.verticalNavMenuCt" />
                </template>
                <!-- /Nav-Group -->
              </template>
            </template>
          </div>
        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div v-if="!isVerticalNavMenuActive" class="v-nav-menu-swipe-area" v-hammer:swipe="onSwipeAreaSwipe" />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import config from "/public/config";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";

import Logo from "../Logo.vue";

export default {
  name: "v-nav-menu",
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
  },
  data: () => ({
    sideTopImage: require('@/assets/images/logo/snb-dgjg.svg'),
    sideTopImageStyle: {
      width: "100%",
      height: "40px",
      margin: "20px",
    },
    hostname: config.HOST_NAME,
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
  }),
  computed: {
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        const pathList = this.$route.path.split("/");
        const activeCode = this.$route.meta ? this.$route.meta.activeCode : undefined;
        let open = false;

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((itemSubmenu) => {
              if (itemSubmenu.url && (path === itemSubmenu.url || (itemSubmenu.activeCode && activeCode === itemSubmenu.activeCode))) {
                open = true;
              } else if (itemSubmenu.submenu) {
                func(itemSubmenu);
              }

              if (itemSubmenu.activeCode) {
                const __index_field = pathList.indexOf('field');
                const __check_field_code = (pathList.length > __index_field + 1) ? pathList[__index_field + 1] : '_none_';
                if (`field-${__check_field_code}` === itemSubmenu.activeCode) open = true;
              }

              if (itemSubmenu.groupName) {
                itemSubmenu.groupName.map((boardId) => {
                  const __index_tab = pathList.indexOf('tab');
                  const __check_tab_code = (pathList.length > __index_tab + 1) ? pathList[__index_tab + 1] : '_none_';
                  if (__check_tab_code === boardId) open = true;

                  const __index_normal = pathList.indexOf('normal');
                  const __check_normal_code = (pathList.length > __index_normal + 1) ? pathList[__index_normal + 1] : '_none_';
                  if (__check_normal_code === boardId) open = true;

                  const __index_approval = pathList.indexOf('approval');
                  const __check_approval_code = (pathList.length > __index_approval + 1) ? pathList[__index_approval + 1] : '_none_';
                  if (__check_approval_code === boardId) open = true;
                });
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {
      if (this.navMenuItems) {
        const clone = this.navMenuItems.slice();

        for (const [index, item] of this.navMenuItems.entries()) {
          if (item.header && item.items.length && (index || 1)) {
            const i = clone.findIndex((ix) => ix.header === item.header);
            for (const [subIndex, subItem] of item.items.entries()) {
              clone.splice(i + 1 + subIndex, 0, subItem);
            }
          }
        }
        return clone;
      }

      return [];
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    reduce(val) {
      const verticalNavMenuWidth = val ? "reduced" : this.$store.state.windowWidth < 1200 ? "no-nav-menu" : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  created() {
    this.loadSideTopImage().then();
    this.loadSideTopImageStyle().then();
  },
  methods: {
    /**
     * 로그인 화면에서 왼편에 표시되는 이미지를 불러온다
     */
    async loadSideTopImage() {
      // 로컬 스토리지에 `${host_name}_side_top_image` 키로 저장된 이미지가 있는지 확인한다.
      // 있으면 그 이미지를 사용하고, 없으면 서버에서 이미지를 가져와서 로컬 스토리지에 저장한다.
      if (localStorage.getItem(`${this.hostname}_side_top_image`)) {
        this.sideTopImage = localStorage.getItem(`${this.hostname}_side_top_image`);
      }

      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "side_top_image",
      });

      // 로컬 스토리지에 저장한다
      localStorage.setItem(`${this.hostname}_side_top_image`, config.path);

      this.sideTopImage = config.path;
    },
    async loadSideTopImageStyle() {
      // 로컬 스토리지에 `${host_name}_side_top_image` 키로 저장된 이미지가 있는지 확인한다.
      // 있으면 그 이미지를 사용하고, 없으면 서버에서 이미지를 가져와서 로컬 스토리지에 저장한다.
      if (localStorage.getItem(`${this.hostname}_side_top_image_style`)) {
        this.sideTopImageStyle = JSON.parse(localStorage.getItem(`${this.hostname}_side_top_image_style`));
      }

      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "side_top_image_style",
      });

      // 로컬 스토리지에 저장한다
      localStorage.setItem(`${this.hostname}_side_top_image_style`, JSON.stringify(config));

      this.sideTopImageStyle = config;
    },

    onMenuSwipe(event) {
      if (event.direction === 4 && this.$vs.rtl) {
        // Swipe Right
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false;
      } else if (event.direction === 2 && !this.$vs.rtl) {
        // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      if (event.direction === 4 && !this.$vs.rtl) {
        // Swipe Right
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true;
      } else if (event.direction === 2 && this.$vs.rtl) {
        // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0;
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = !!this.reduceButton;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!(this.reduceButton && !this.isMouseEnter);
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", verticalNavMenuItemsMin);

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced ? "reduced" : "default";
          this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },

    // groupItem.slug 설정과 상관없이 url이 http, https로 시작하는 경우 외부 링크로 연결해주기 위함.
    isExternal(url) {
      return typeof url === "string" && (url.indexOf("http") === 0 || url.indexOf("https") === 0);
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

.smallMenu {
  .vs-sidebar {
    max-width: 70%;
  }
}
</style>
